import React, { useEffect, useState } from 'react'
import styles from '../ipTv.jcss'
import translate from '../../../core/translate'
import { Header } from '../__header/Header'
import { cn } from 'ethcss'
import { ChannelAdd } from '../__channelAdd/ChannelAdd'
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import Icon from '../../../blocks.simple/icon/icon'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'
import Button from '../../../blocks.simple/button/button'
import { Search } from '../__search/Search'
import { api } from '../../../core/api/ConnectionManager'
import InfiniteScroll from 'react-infinite-scroller'
import LoaderLazy from 'blocks.app/loader/_lazy/loader__lazy'
import Tippy from 'blocks.simple/tippy/tippy'
import { PresetApply } from '../__presetApply/PresetApply'
import { Switch } from '../../../atoms/Switch'

export interface IChannel {
    globalVisible: boolean
    id?: number
    title: string
    channelNumber: string
    channelUrl: string
    logo: any
    category?: any
    categoryId?: number
    order?: number
    visible?: boolean
    preset: {
        enabled: boolean
        name: string
        vlcViewType: string
        vlcSettingString: string
    }
}

export const Channels = () => {
    const [channelList, setChannelList] = useState<IChannel[]>([])
    const [selectedItems, setSelectedItems] = useState<number[]>([])
    const [channelData, setChannelData] = useState<IChannel | null>(null)
    const [search, setSearch] = useState<string>('')
    const [deleteConfirm, setDeleteConfirm] = useState<any>(null)
    const [multipleDeleteConfirm, setMultipleDeleteConfirm] = useState<boolean>(false)
    const [nextPageTokenRes, setNextPageTokenRes] = useState<string>('')
    const [preset, setPreset] = useState<boolean>(false)

    useEffect(() => {
        getChannelList(search, null)
    }, [search])

    const getChannelList = (query: string, nextPageToken: any) => {
        const data: any =
            nextPageToken === null
                ? {
                      limit: 15,
                      sort: [['order', 'ASC']],
                  }
                : {
                      nextPageToken: nextPageToken,
                      limit: 10,
                  }

        if (query) {
            data.query = query
        }

        api.send('getChannelList', data).then((res: any) => {
            if (!res && !res.data) return

            setNextPageTokenRes(res.nextPageToken)

            if (nextPageToken) {
                setChannelList([...channelList, ...res.data])
            } else {
                setChannelList(res.data)
            }
        })
    }
    const onSelectItem = (id: number) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter((item) => item !== id))
            return
        }

        setSelectedItems([id, ...selectedItems])
    }
    const onDeleteItem = (id: number) => {
        api.send('deleteChannel', { ids: [id] }).then(() => setDeleteConfirm(null))
    }
    const deleteAllSelected = () => {
        api.send('deleteChannel', { ids: selectedItems }).then(() => setMultipleDeleteConfirm(false))
    }
    const onCancelDelete = () => {
        setDeleteConfirm(null)
        setMultipleDeleteConfirm(false)
    }
    const onDeleteConfirm = (id: number) => {
        setDeleteConfirm(id)
    }
    const onMultipleDeleteConfirm = () => {
        setMultipleDeleteConfirm(true)
    }
    const selectAll = () => {
        setSelectedItems(channelList.map((channel: any) => channel.id))
    }
    const clearSelection = () => {
        setSelectedItems([])
    }
    const dropdownSelect = (select: any) => {
        if (select.id === 'selectAll') {
            selectAll()
            return
        }

        clearSelection()
    }
    const onSortEnd = ({ oldIndex, newIndex }: { oldIndex: number; newIndex: number }) => {
        const sortedList = arrayMove(channelList, oldIndex, newIndex).slice()
        setChannelList(sortedList)
        api.send('updateChannel', { id: sortedList[newIndex].id, order: newIndex })
    }
    const onAddChannel = () => {
        setChannelData({
            title: '',
            channelNumber: '',
            channelUrl: '',
            logo: null,
            category: null,
            preset: {
                enabled: false,
                name: 'NetUp',
                vlcViewType: 'surface',
                vlcSettingString:
                    '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --repeat --network-caching=1000',
            },
            globalVisible: true,
        })
    }
    const onEditChannel = (channel: IChannel) => {
        setChannelData(channel)
    }
    const onChannelChange = (field: string, value: any) => {
        if (channelData) {
            setChannelData({
                ...channelData,
                [field]: value,
            })
        }
    }
    const onCloseModal = () => {
        setChannelData(null)
    }

    const onSaveChannel = () => {
        if (!channelData) return

        const data: any = {
            title: channelData.title,
            channelUrl: channelData.channelUrl.trim(),
            channelNumber: channelData.channelNumber ? Number(channelData.channelNumber) : channelData.channelNumber,
            logoSourceId: channelData.logo ? channelData.logo.id : null,
            categoryId: channelData.category ? channelData.category.id : null,
            preset: channelData.preset ? channelData.preset : null,
            globalVisible: channelData.globalVisible ? channelData.globalVisible : false,
        }

        if (channelData.id) {
            data.id = channelData.id
            api.send('updateChannel', data).then(onCloseModal)
            return
        }

        api.send('createChannel', data)
            .then(onCloseModal)
            .catch((error: { errorCode?: number | string }) => {
                if (Number(error?.errorCode) === 81) {
                    onCloseModal()
                }
            })
    }
    const onUpdateChannelVisibility = (id: number, globalVisible: boolean) => {
        api.send('updateChannel', { id, globalVisible }).then(onCloseModal)
    }
    const onChannelCreated = (channel: IChannel) => {
        setChannelList((prev) => {
            if (prev.some((el) => el.id === channel.id)) {
                return prev
            }

            return [channel, ...prev]
        })
        setChannelData((prev) => (prev && !prev.id ? null : prev))
    }
    const onChannelUpdated = (channel: IChannel) => {
        setChannelList(
            channelList.map((el: IChannel) => {
                if (el.id === channel.id) {
                    return channel
                }

                return el
            })
        )
    }
    const onChannelDeleted = (res: any) => {
        setChannelList(channelList.filter((channel) => !res.find((el: any) => el.id === channel.id)))
    }
    const applyPreset = () => {
        setPreset(true)
    }
    const onCancelApplyPreset = () => {
        setPreset(false)
        setSelectedItems([])
    }
    const onPresetUpdated = (data: any) => {
        if (!data) return

        setChannelList(
            channelList.map((channel) => {
                if (data.id.includes(channel.id)) {
                    return {
                        ...channel,
                        preset: data.preset,
                    }
                }

                return channel
            })
        )
    }
    const SortableList = SortableContainer(({ items }: any) => (
        <ul className={styles.listWrapper}>
            {items.map((channel: any, index: number) => (
                <SortableItem
                    channel={channel}
                    key={channel.id}
                    index={index}
                    onDelete={onDeleteItem}
                    onSelect={onSelectItem}
                />
            ))}
        </ul>
    ))
    const DragHandle = SortableHandle(() => (
        <div className={styles.handle}>
            <Icon type={'sortable_handle'} />
        </div>
    ))
    const SortableItem = SortableElement(({ channel }: any) => {
        return (
            <li className={styles.channel}>
                <div className={styles.checkbox}>
                    <DragHandle />
                    <Checkbox checked={selectedItems.includes(channel.id)} onClick={() => onSelectItem(channel.id)} />
                </div>
                <div className={styles.channelNumber}>
                    <Tippy title={channel.channelNumber} disabled={channel.channelNumber.length < 16}>
                        {channel.channelNumber}
                    </Tippy>
                </div>
                <div className={styles.channelLogo}>
                    {channel.logo ? <img src={channel.logo.src} /> : <Icon type={'noChannel'} size={40} />}
                </div>
                <div className={styles.channelName}>
                    <Tippy title={channel.title} disabled={channel.title.length < 16}>
                        {channel.title}
                    </Tippy>
                </div>
                <div className={styles.channelUrl}>
                    <Tippy title={channel.channelUrl} disabled={channel.channelUrl.length < 16}>
                        {channel.channelUrl}
                    </Tippy>
                </div>
                <div className={styles.channelCategory}>
                    <Tippy
                        title={channel.category ? channel.category.title : translate('all')}
                        disabled={channel.category && channel.category.title.length < 16}
                    >
                        {channel.category ? channel.category.title : translate('all')}
                    </Tippy>
                </div>
                <div className={styles.channelPreset}>
                    <Tippy
                        title={channel.category ? channel.category.title : translate('all')}
                        disabled={channel.category && channel.category.title.length < 16}
                    >
                        {channel.preset ? (
                            channel.preset.enabled ? (
                                translate(channel.preset.name)
                            ) : (
                                <span>{translate(channel.preset.name)}</span>
                            )
                        ) : (
                            '—'
                        )}
                    </Tippy>
                </div>
                <div className={styles.channelVisibility}>
                    <Switch
                        onChange={() => {
                            onUpdateChannelVisibility(channel.id, !channel.globalVisible)
                        }}
                        checked={channel.globalVisible}
                    />
                    <div className={styles.channelChangeButtons}>
                        <div>
                            <Icon type={'pencil'} onClick={() => onEditChannel(channel)} />
                        </div>
                        <div>
                            <Icon type={'delete'} onClick={() => onDeleteConfirm(channel.id)} />
                        </div>
                    </div>
                </div>
            </li>
        )
    })

    useEffect(() => {
        const listenersId: string[] = []
        api.addObserver('channelCreated', onChannelCreated, listenersId)
        api.addObserver('channelUpdated', onChannelUpdated, listenersId)
        api.addObserver('channelDeleted', onChannelDeleted, listenersId)
        api.addObserver('iptvPresetUpdated', onPresetUpdated, listenersId)

        return () => listenersId.forEach((id) => api.removeObserver(id))
    }, [channelList])

    return (
        <>
            <Search search={search} setSearch={setSearch} dropdownSelect={dropdownSelect} />
            <div className={cn(styles.wrapper, styles.scrollWrapper)}>
                <Header
                    selectedItemsLength={selectedItems.length}
                    deleteAllSelected={onMultipleDeleteConfirm}
                    onAdd={onAddChannel}
                    applyPreset={applyPreset}
                />
                <div className={styles.tableDisplay}>
                    <div className={cn(styles.channel, styles.channelsHeader, styles.widthFull)}>
                        <div className={styles.checkbox}>
                            <span className={styles.checkboxHeader}>{translate('choice')}</span>
                        </div>
                        <div className={styles.channelNumber}>{translate('number')}</div>
                        <div className={styles.channelLogo}>{translate('logo')}</div>
                        <div className={cn(styles.channelName, styles.nameHeader)}>{translate('name')}</div>
                        <div className={styles.channelUrl}>{translate('ipAddress')}</div>
                        <div className={styles.channelCategory}>{translate('category')}</div>
                        <div className={styles.channelPreset}>{translate('preset')}</div>
                        <div className={styles.channelVisibility}>{translate('channelVisibility')}</div>
                    </div>
                    <InfiniteScroll
                        className={styles.widthFull}
                        loadMore={() => getChannelList(search, nextPageTokenRes)}
                        hasMore={nextPageTokenRes !== null}
                        initialLoad={false}
                        loader={<LoaderLazy key="iptv_loader" active />}
                        threshold={10}
                    >
                        <SortableList items={channelList} useDragHandle={true} onSortEnd={onSortEnd} />
                    </InfiniteScroll>
                </div>
            </div>
            <ChannelAdd
                channel={channelData}
                onChange={onChannelChange}
                onClose={onCloseModal}
                onSave={onSaveChannel}
            />
            {preset && <PresetApply selectedItems={selectedItems} onClose={onCancelApplyPreset} />}
            {(deleteConfirm || multipleDeleteConfirm) && (
                <div className={styles.deleteConfirmWrapper}>
                    <div className={styles.deleteConfirm}>
                        <div>{translate(deleteConfirm ? 'deleteChannelConfirm' : 'deleteChannelsConfirm')}</div>
                        <div className={styles.controls}>
                            <Button mod={'withBorder'} className={styles.button} onClick={onCancelDelete}>
                                {translate('cancel')}
                            </Button>
                            <Button
                                mod={'fill'}
                                className={styles.button}
                                onClick={() => (deleteConfirm ? onDeleteItem(deleteConfirm) : deleteAllSelected())}
                            >
                                {translate('delete')}
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
